import { useCallback, useContext, memo } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextArea from 'components/textArea';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepTwoContext } from '../../../campaignFormStepTwo.context';
import CampaignFormField from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormSteps/components/campaignFormFieldGroup/components/campaignFormField/campaignFormField';

const OtherRequestsField = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { validateDocumentOrSnsPlatformsInText } = useContext(CampaignFormStepTwoContext);

  const otherRequestsValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'OTHER_REQUESTS.value',
  });

  const onChangeOtherRequests = useCallback((value: string) => {
    guidelineRuleFormMethods.setValue('OTHER_REQUESTS.value', value);
  }, []);

  const onBlurReelsGuidelineEtc = useCallback(() => {
    if (otherRequestsValue) {
      validateDocumentOrSnsPlatformsInText(otherRequestsValue as string);
    }
  }, [otherRequestsValue]);

  return (
    <CampaignFormField description={languageTexts.show_text_59}>
      <TextArea
        id="otherRequests"
        value={otherRequestsValue || ''}
        bordered
        placeholder={languageTexts.campaign_form_other_requests_placeholder}
        onChangeText={onChangeOtherRequests}
        onBlur={onBlurReelsGuidelineEtc}
        autoResize={true}
        inputStyle={{ display: 'block', minHeight: '83.52px' }}
      />
    </CampaignFormField>
  );
};

export default memo(OtherRequestsField);
